export const base = '/messages';
